import React from 'react';
import { View, ScrollView } from 'react-native';

import { AnimatedShimmer, BackgroundShimmer } from './CommonShimmer';
import { HorizontalDivider } from '../../utils/widgets/Common-Widget';

import AppTheme from "../../AppTheme";
import AppStyles from '../../AppStyles';
import Colors from '../../utils/constants/AppColors';

export const DealShimmer = (props) => {
    return (
        <ScrollView style={{ width: AppTheme.appWidth }}>
            {[1, 2, 3, 4].map((i) => {
                return <View key={i}>
                    <AnimatedShimmer height={140} width={AppTheme.appWidth} borderRadius={0} />
                    <View style={[AppStyles.flexRowStart,
                    { position: "absolute", left: 16, top: 25 }]}>
                        <BackgroundShimmer height={90} width={90} borderRadius={4}
                            backgroundColor={Colors.grey.shimmer} />
                        <View style={[AppStyles.ml16, { height: 90 }]}>
                            <BackgroundShimmer height={12} width={AppTheme.appWidth * 0.20}
                                marginTop={0} borderRadius={6} backgroundColor={Colors.grey.shimmer} />
                            <BackgroundShimmer height={10} width={AppTheme.appWidth * 0.20}
                                marginTop={6} borderRadius={5} backgroundColor={Colors.grey.shimmer} />
                            <BackgroundShimmer height={10} width={AppTheme.appWidth * 0.35}
                                marginTop={8} borderRadius={5} backgroundColor={Colors.grey.shimmer} />
                            <BackgroundShimmer height={28} width={115} marginTop={16}
                                borderRadius={14} backgroundColor={Colors.grey.shimmer} />
                        </View>
                    </View>
                    <HorizontalDivider width={AppTheme.appWidth} />
                </View>
            })}
        </ScrollView>
    )
}
